export const client: RECO.Mobile.Config.Client = (window["client"] = {
    title: "“浦东青年”综合服务信息化平台",
    techSupport: "技术支持:  上海瑞谷拜特软件技术有限公司",
    urlArgs: "v=180427",
    tel: "021-20231080",
    /**
     * 是否在Header里调用查询工单的接口
     */
    isgetOrderOnHeader: true,
    /**
     * 默认园区code
     */
    parkCode: "gongqtshspdxqwyh",
    /**
     * 作为区分同一域名下不同网页的缓存的关键字
     */
    appDomain: "ipark_web",
    /**
     * 是否使用高德地图
     */
    isUseGDMap: false,
    /**
     * 是否开启认证完整性校验
     */
    enableAuthIntegrity: true,
    ...window["client"],
    app: {
        /** 是否开启行政审批 */
        openAdminiApproval: true,
        /** 是否开启招聘 */
        openRecruit: true,
        /** 是否开启企业主页 */
        openEnterpriseHome: true,
        /** 是否政策申报 */
        openPolicyDeclare: true,
    },
});

const config = location.href.includes(`pdyouth.net`)
    ? {
        appdownURL: "", // app下载地址
        jsonURL: "", // seo生成json文件路径
        base: "/",
        webappurl: "//www.pdyouth.net/pdqn/#/", // 后台地址
        assetsUrl: "//www.pdyouth.net/mobileapi/", // 图片存放地址，用于富文本中获取图片
        url: "//www.pdyouth.net/mobileapi/", // 接口地址
        jsURL: "//www.pdyouth.net/assets/js", // website js地址
    } :
    location.href.includes(`pdyouth.org`)
        ? {
            appdownURL: "", // app下载地址
            jsonURL: "", // seo生成json文件路径
            base: "/",
            webappurl: "//www.pdyouth.org/pdqn/#/", // 后台地址
            assetsUrl: "//www.pdyouth.org/mobileapi/", // 图片存放地址，用于富文本中获取图片
            url: "//www.pdyouth.org/mobileapi/", // 接口地址
            jsURL: "//www.pdyouth.org/assets/js", // website js地址
        }
        : location.href.includes(`fat.bitechdevelop.com`)
            ? {
                appdownURL: "//demo.bitech.cn/iparkappjavaalpha/", // app下载地址
                jsonURL: "//dev.bitechdevelop.com/reco.ipark.cms/webSeo.json", // seo生成json文件路径
                base: "/pdyouth-website/",
                webappurl: "https://fat.bitechdevelop.com/pdyouth-webapp/#/", // 后台地址
                assetsUrl: "https://fat.bitechdevelop.com/pdyouth-mobileapi/", // 图片存放地址，用于富文本中获取图片
                url: "https://fat.bitechdevelop.com/pdyouth-mobileapi/", // 接口地址
                jsURL: "https://fat.bitechdevelop.com/pdyouth-website/assets/js", // website js地址
            }
            : {
                appdownURL: "//demo.bitech.cn/iparkappjavaalpha/", // app下载地址
                jsonURL: "//dev.bitechdevelop.com/reco.ipark.cms/webSeo.json", // seo生成json文件路径

                base: "/pdyouth-website/",
                webappurl: "https://fat.bitechdevelop.com/pdyouth-webapp/#/", // 后台地址
                assetsUrl: "https://fat.bitechdevelop.com/pdyouth-mobileapi/", // 图片存放地址，用于富文本中获取图片
                url: "https://fat.bitechdevelop.com/pdyouth-mobileapi/", // 接口地址
                jsURL: "https://fat.bitechdevelop.com/pdyouth-website/assets/js", // website js地址
            };

export const server: RECO.Mobile.Config.Server = (window["server"] = {
    apiKey: {
        apiKey: "Bitech\\PC",
        secret: "44678314ba0efa0c",
    },
    apiVersion: 9,
    auth: {
        oauth2Url: "authorization/oauth2",
        autoLogin: !0,
        autoRefreshToken: !0,
        anonymousLogin: !0, ////
    },
    rsa: {
        enable: true,
        publicKey: `MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDXu1ms9TrhrMlIn3iv4g2Pw9Mfr9abdAB-TpDD65G98wjHZxgkZfhzUHE8BSsUDzIHfOiCd4RT5fZtTiop9bzwecgYCrAICjrVC-8ZWKf1RqRX4EXiISyEBHb4YAER_Rt2TQEWGPCi14ujDTA9qr1_YRUFfh52nrc-MfkfC12BwQIDAQAB`,
    },
    ...config,
    ...window["server"],
});
